import axios from "axios";
import { getSessinIdFromLS } from "./storage/LocalStorage";

const request = axios.create({
	timeout: 100000,
});

function getHeaders() {
	const sessionId = getSessinIdFromLS();
	if (sessionId) {
		return {
			sessionId: sessionId,
		};
	}
}

function get(url) {
	let options = {
		method: "get",
		url: url,
		headers: getHeaders(),
	};
	return request(options).then(handleResponse).catch(handleError);
}

function downloadFile(url) {
	let options = {
		method: "get",
		url: url,
		headers: getHeaders(),
		responseType: "blob",
	};

	return request(options).then(handleResponse).catch(handleError);
}

function downloadBotFile(url) {
	let options = {
		method: "get",
		url: url,
		headers: getHeaders(),
	};

	return request(options).then(handleResponse).catch(handleError);
}

function downloadSignedUrlFile(url) {
	let options = {
		method: "get",
		url: url,
		headers: { ...getHeaders() },
	};

	return request(options).then(handleResponse).catch(handleError);
}

function uploadFile(url, file, contentType, onUploadProgress) {
	let options = {
		method: "post",
		url: url,
		data: file,
		onUploadProgress: onUploadProgress,
	};
	options.headers = { ...getHeaders(), "content-type": contentType };
	return request(options).then(handleResponse).catch(handleError);
}

export default {
	get,
	downloadFile,
	downloadSignedUrlFile,
	uploadFile,
	downloadBotFile,
};

function handleResponse(response) {
	console.log('rwsss',response)
	return response.data;
}

function handleError(error) {
	if (!error || !error.response) {
		// NotifyClassComp({
		// 	type: "error",
		// 	message: "Network error has occurred. Please try again",
		// });
		console.error('Network error has occurred. Please try again')
	}

	throw Error;
}
